import { useEffect, useState } from "react";
import { getSystemAlerts, MarkAsResolved } from "../../../services/system_alerts";

export default function useSystemAlerts() {
  const [isLoading, setIsLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);
  const [viewLastDays, setViewLastDays] = useState(30);

  const handleChangeView = (viewLastDays) => {
    setViewLastDays(viewLastDays);
    setIsLoading(true);
  };

  const fetchData = async () => {
    const data = await getSystemAlerts(viewLastDays);
    if (data) {
      setAlerts(data);
    }
    setIsLoading(false);
  };

  const handleMarkAsResolved = async (alert) => {
    const result = await MarkAsResolved(alert);
    if (result) fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [viewLastDays]);

  return {
    isLoading,
    alerts,
    viewLastDays,
    handleChangeView,
    handleMarkAsResolved,
    reloadTable: fetchData,
  };
}